module.exports = __webpack_public_path__ + "static/media/welcome-slider-2-es-md.7cc985ad.png";